
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/LeanProjectSelect/LeanProjectSelect.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./LeanProjectSelect.html');
        
        var script = require('./LeanProjectSelect.ts').default;
        module.exports = require('./LeanProjectSelect.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    